// extracted by mini-css-extract-plugin
export default {"wrapper":"payment-summary_wrapper__kh-LG","title":"payment-summary_title__MuVQp"};